/**
 * Module that splits a large Array into a new container Array with smaller arrays.
 *
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module split-array-into-batches.js
 * @class SplitArrayIntoBatches
 * @since 0.7.5
*/

/**
* Splits a large Array into a new container Array with smaller arrays.
*
* @method split
* @param list {Array} the original large array
* @param maxBatch {Number} the maximum of items a smaller Array may hold
* @return {Array} Container Array with smaller Arrays as items
* @since 0.7.5
*/
const split = (list, maxBatch) => {
    const batchList = [];
    while (list.length > maxBatch) {
        batchList.push(list.slice(0, maxBatch));
        list = list.slice(maxBatch);
    }
    // add remainer:
    batchList.push(list);
    return batchList;
};

module.exports = {
    split
};
